module.exports = __webpack_public_path__ + "socicon.9a64ef938f9e55a70a4d.ttf";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/socicon/font/socicon.ttf
// module id = ../../../../socicon/font/socicon.ttf
// module chunks = styles